"use client";

import * as React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { CircleCheck, ArrowRight, Map, Compass, Ruler, HardHat, Building2, Mountain } from "lucide-react";
const servicesData = [{
  id: "ad-spot",
  code: "SPOT-01",
  title: "Размещение рекламных мест",
  description: "Эксклюзивное присутствие вашего бренда на премиальных ко-оп открытках. Мы гарантируем отсутствие конкурентов в вашей категории в каждом тираже.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/ad_spot_placement.png",
  icon: Building2,
  features: ["Один бизнес на категорию", "Охват 2,500+ домохозяйств", "Премиальный плотный картон", "Прямая доставка через USPS EDDM"]
}, {
  id: "qr-tracking",
  code: "DATA-02",
  title: "QR-код и аналитика",
  description: "Отслеживайте эффективность вашей кампании в реальном времени с помощью индивидуальных QR-кодов и детальной панели мониторинга.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/qr_code_tracking.png",
  icon: Compass,
  features: ["Уникальные динамические QR-коды", "Отслеживание конверсии в реальном времени", "Географическая привязка сканирований", "Ежемесячные отчеты об эффективности"]
}, {
  id: "custom-design",
  code: "DSGN-03",
  title: "Индивидуальный дизайн",
  description: "Профессиональная разработка макета, который выделит ваше предложение и подчеркнет статус вашего бизнеса перед премиальной аудиторией.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/custom_graphic_design.png",
  icon: Ruler,
  features: ["Индивидуальная концепция макета", "Профессиональный копирайтинг", "Оптимизация под формат EDDM", "Неограниченное количество правок"]
}, {
  id: "eddm-mailing",
  code: "MAIL-04",
  title: "Почтовая рассылка EDDM",
  description: "Полный цикл логистики: от подготовки адресных планов до физической доставки в почтовые ящики целевых микрорайонов.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/usps_eddm_mailing.png",
  icon: Map,
  features: ["Таргетинг на Johns Creek и Атланту", "Взаимодействие с почтовой службой", "Гарантированная доставка в руки", "Высокий доход целевой аудитории"]
}, {
  id: "strategy",
  code: "STRT-05",
  title: "Маркетинговая стратегия",
  description: "Разработка долгосрочного плана присутствия вашего бренда в почтовых ящиках самых обеспеченных жителей региона.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/marketing_strategy.png",
  icon: HardHat,
  features: ["Анализ конкурентной среды", "Выбор оптимальных маршрутов", "Сезонное планирование акций", "Интеграция с онлайн-каналами"]
}, {
  id: "expansion",
  code: "EXPN-06",
  title: "Расширение охвата",
  description: "Масштабируйте свой успех вместе с нами по мере нашего расширения в новые районы Метро Атланты.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/atlanta_expansion.png",
  icon: Mountain,
  features: ["Приоритет в новых локациях", "Скидки для сетевых партнеров", "Кросс-районные кампании", "Растущая база лояльных клиентов"]
}];
export default function MainServices() {
  return <section data-section-id="239763" id="our-expertise" className="bg-background text-foreground py-24 lg:py-32 relative">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-6 font-default tracking-tight">
            Наши основные услуги
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            The Peachtree Post помогает локальному бизнесу Атланты находить путь к сердцам и дверям 
            самых обеспеченных домовладельцев через премиальный директ-мейл.
          </p>
        </div>

        <Tabs defaultValue={servicesData[0].id} className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          
          {}
          <TabsList className="flex-col h-auto w-full lg:w-1/3 items-stretch bg-transparent p-0 gap-3">
            {servicesData.map((service, i) => {
            const Icon = service.icon;
            return <TabsTrigger key={service.id} value={service.id} data-index={i} className="justify-start text-left px-6 py-5 h-auto rounded-sm border border-border bg-card hover:border-primary/40 data-[state=active]:border-primary data-[state=active]:bg-accent data-[state=active]:shadow-lg transition-all duration-300 group relative overflow-hidden whitespace-normal">
                  <div className="flex items-center gap-4 w-full">
                    <div className="p-2 rounded-sm bg-muted text-secondary group-data-[state=active]:bg-primary group-data-[state=active]:text-primary-foreground transition-colors">
                      <Icon className="w-5 h-5" />
                    </div>
                    <span className="font-default text-base font-semibold text-secondary group-data-[state=active]:text-secondary transition-colors flex-1">
                      {service.title}
                    </span>
                  </div>
                  
                  {}
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300 font-mono text-xs font-medium text-muted-foreground bg-background/90 px-2 py-1 rounded-sm border border-border shadow-sm backdrop-blur-sm translate-x-2 group-hover:translate-x-0">
                    {service.code}
                  </span>
                </TabsTrigger>;
          })}
          </TabsList>

          {}
          <div className="w-full lg:w-2/3">
            {servicesData.map((service, i) => <TabsContent key={service.id} value={service.id} data-index={i} className="mt-0 outline-none focus-visible:ring-0">
                <div className="bg-card border border-border rounded-sm p-6 md:p-8 lg:p-10 shadow-xl flex flex-col gap-8 animate-in fade-in slide-in-from-right-8 duration-500 fill-mode-both">
                  
                  {}
                  <div className="relative h-64 md:h-80 w-full rounded-sm overflow-hidden group">
                    <img src={service.image} alt={service.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-secondary/90 via-secondary/20 to-transparent"></div>
                    <div className="absolute bottom-6 left-6 right-6 flex justify-between items-end">
                      <h3 className="text-2xl md:text-3xl font-bold text-white font-default max-w-lg leading-tight">
                        {service.title}
                      </h3>
                      <span className="hidden md:inline-block font-mono text-sm text-white/70 bg-black/40 px-3 py-1.5 rounded-sm backdrop-blur-md border border-white/10">
                        {service.code}
                      </span>
                    </div>
                  </div>

                  {}
                  <div className="flex flex-col md:flex-row gap-8 lg:gap-12">
                    <div className="flex-1">
                      <p className="text-muted-foreground mb-8 text-lg leading-relaxed font-default">
                        {service.description}
                      </p>
                      
                      <div className="space-y-4">
                        <h4 className="font-default font-semibold text-secondary text-lg">
                          Ключевые преимущества:
                        </h4>
                        <ul className="space-y-3">
                          {service.features.map((feature, j) => <li key={j} data-index={j} className="flex items-start gap-3">
                              <CircleCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                              <span className="text-foreground font-default">{feature}</span>
                            </li>)}
                        </ul>
                      </div>
                    </div>
                    
                    {}
                    <div className="md:w-1/3 flex flex-col justify-end pt-6 md:pt-0 border-t md:border-t-0 md:border-l border-border md:pl-8">
                      <div className="bg-muted/50 rounded-sm p-6 text-center mb-6">
                        <p className="text-sm text-muted-foreground mb-2 font-default">
                          Готовы занять свое место?
                        </p>
                        <p className="font-default font-semibold text-secondary">
                          Забронируйте категорию в следующем тираже по Johns Creek.
                        </p>
                      </div>
                      <Button size="lg" className="w-full group bg-gradient-to-b from-primary to-primary/90 text-primary-foreground rounded-sm shadow-md hover:shadow-lg transition-all" asChild>
                        <Link to="/ContactPage">
                          Запросить расчет
                          <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                        </Link>
                      </Button>
                    </div>
                  </div>

                </div>
              </TabsContent>)}
          </div>

        </Tabs>
      </div>
    </section>;
}